import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage, injectIntl, IntlShape} from "react-intl";
import {useAppDispatch, useAppSelector} from "../../../storeHooks";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import IconButton from "@mui/material/IconButton";
import {setUiPopupState} from "../../../actions/actionFunctions";

type UiPopupAIContentEditingModalProps = {
  propsOpened: boolean;
  propsTitle: string;
  propsValue: string;
  propsClose: (value: string) => void;
  intl: IntlShape
};

function UiPopupAIContentEditingModal(props: UiPopupAIContentEditingModalProps) {

  const {propsOpened, propsTitle, propsValue, propsClose, intl} = props;

  const dispatch = useAppDispatch();
  const {uiPopupState} = useAppSelector(state => state.messageBoxState);

  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (!propsOpened) {
      setInputValue("");
      return;
    }

    setInputValue(propsValue || "");

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!inputRef.current) return;

        inputRef.current.focus();
        inputRef.current.scrollTop = 0;
      });
    });
  }, [propsOpened, propsValue]);

  useEffect(() => {
    if (!propsOpened) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") propsClose(propsValue || "");
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [propsOpened, propsValue, propsClose]);

  const onClose = () => propsClose(inputValue)

  const onTextAreChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInputValue(event.target.value);
  }

  const alreadyExpanded = uiPopupState.style?.maxWidth === "95%";

  return (
    <div className={"overlay fixed" + (propsOpened ? "" : " overlay--hidden")}>
      <div className="ui-popup ui-popup--common flex flex--column" style={{
        maxWidth: alreadyExpanded ? "95%" : "80%",
        maxHeight: alreadyExpanded ? "95%" : "80%",
      }}>
        <div className="flex flex--between bordered u-pl-15 u-pr-075 u-pt-05 u-pb-05 u-w-full text-left">
          <span className="ui-popup__header-title">
            {propsTitle}
          </span>
          <IconButton aria-label={intl.formatMessage({id: "iconButton.more"})}
                      className="look-icon look-icon--small look-icon--white2 rounded-full"
                      onClick={() => dispatch(setUiPopupState({
                        ...uiPopupState,
                        style: alreadyExpanded
                          ? {maxWidth: "1280px", maxHeight: "640px"}
                          : {maxWidth: "95%", maxHeight: "95%"}
                      }))}>
            <AspectRatioIcon className="u-h-125 u-w-125"/>
          </IconButton>
          {/*<button className="ui-close" onClick={() => closePopup(true)}/>*/}
        </div>
        <div className="ui-popup__content u-pr-075 u-pl-075 u-w-full u-pt-15">
          <textarea
            ref={inputRef}
            className="u-h-full u-w-full ui-input"
            value={inputValue}
            onChange={onTextAreChange}
          />
        </div>
        <div className="w-full text-right u-p-15">
          <button className={"ui-button2 text-uppercase ui-button2--blue"}
                  onClick={() => propsClose(propsValue || "")}>
            <FormattedMessage id="buttons.cancel"/>
          </button>
          <button className={"margin-l-16 ui-button2 text-uppercase ui-button2--green"}
                  onClick={onClose}>
            <FormattedMessage id="buttons.save"/>
          </button>
        </div>
      </div>
    </div>
  )
}

export default injectIntl(UiPopupAIContentEditingModal)
